<template>
  <div>
   <div class="grid-row mt-5 mb-5">
      <div class="titulo-grid">
        <h6>
          Viabilidade Pré Venda - Dados da SEV
        </h6>
      </div>
    </div>
    <hr>
  <div v-if="pcoCircuitoSSA.code != '0'">
    <div class="titulo-center destaque-texto mb-3 col-md-3">
      <SGPAlertaComponent><b>SEV Inválida</b></SGPAlertaComponent>
    </div>
    <div class="row mb-5 ml-3">
      <div class="col-md-12">
        <div class="titulo">
          Número da SEV
        </div>
        <div class="">
          {{ numeroSev }}
        </div>
      </div>
      <div class="col-md-12">
        <div class="titulo">
          Mensagem
        </div>
        <div class="">
          {{ pcoCircuitoSSA.message || '-'}}
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row">
      <div class="col-md-3">
        <div class="titulo">
          Número da SEV
        </div>
        <div class="">
          {{ numeroSev }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Serviço
        </div>
        <div class="">
          {{ pcoCircuitoSSA.product_specification_type || '-' }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Sigla Serviço
        </div>
        <div class="">
          {{ pcoCircuitoSSA.product_acronym || '-' }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Status SEV
        </div>
        <div class="">
          {{ pcoCircuitoSSA.interaction_status || '-' }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="titulo">
          Validade
        </div>
        <div class="">
          {{ pcoCircuitoSSA.service_solution_delivery_estimated_time || '-' }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Data de Vencimento
        </div>
        <div class="">
          {{ formataDataBr(pcoCircuitoSSA.service_solution_expiry_date, true) || '-' }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Provedor
        </div>
        <div class="">
          {{ pcoCircuitoSSA.specification_type || '-' }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Tipo Logradouro
        </div>
        <div class="">
          {{ pcoCircuitoSSA.street_type || '-' }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="titulo">
          Logradouro
        </div>
        <div class="">
          {{ pcoCircuitoSSA.street_name || '-' }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Número
        </div>
        <div class="">
          {{ pcoCircuitoSSA.street_nr || '-' }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Complemento
        </div>
        <div class="">
          {{ pcoCircuitoSSA.complement || '-' }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Bairro
        </div>
        <div class="">
          {{ pcoCircuitoSSA.neighborhood || '-' }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="titulo">
          Município
        </div>
        <div class="">
          {{ pcoCircuitoSSA.locality || '-' }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          UF
        </div>
        <div class="">
          {{ pcoCircuitoSSA.acronym_state_or_province || '-' }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          CEP
        </div>
        <div class="">
          {{ pcoCircuitoSSA.post_code || '-'}}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Facilidade
        </div>
        <div class="">
          {{ pcoCircuitoSSA.specification_category || '-'}}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="titulo">
          Fornecedor
        </div>
        <div class="">
          {{ pcoCircuitoSSA.access_service_provider || '-'}}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Estação de Acesso
        </div>
        <div class="">
          {{ pcoCircuitoSSA.acesso_estacao_entroncamento || '-'}}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Custo de Acesso
        </div>
        <div class="">
          {{ pcoCircuitoSSA.custo_acesso || '-'}}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Custo Total
        </div>
        <div class="">
          {{ pcoCircuitoSSA.custo_total || '-'}}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="titulo">
          Custo Terceiros
        </div>
        <div class="">
          {{ pcoCircuitoSSA.custo_terceiro || '-'}}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Latitude
        </div>
        <div class="">
          {{ pcoCircuitoSSA.latitude_resposta || '-'}}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Longitude
        </div>
        <div class="">
          {{ pcoCircuitoSSA.longitude_resposta || '-'}}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Reserva Backbone IP
        </div>
        <div class="">
          {{ pcoCircuitoSSA.reserva_backbone_ip || '-' }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="titulo">
          Reserva Backbone Telefonia
        </div>
        <div class="">
          {{ pcoCircuitoSSA.reserva_backbone_telefonia || '-' }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Observações
        </div>
        <div class="">
          {{ pcoCircuitoSSA.service_solution_description || '-' }}
        </div>
      </div>
      <div class="col-md-3">
        <div class="titulo">
          Mensagem
        </div>
        <div class="">
          {{ pcoCircuitoSSA.message || '-' }}
        </div>
      </div>
    </div>
  </div>
 </div>  
</template>

<script>

import { formataDataBr } from '@/common/boot/Utils'

export default {
  name: "InformacoesDadosSevComponent",
  props: {
    pcoCircuitoSSA: {
      type: Array,
      required: true
    },
    numeroSev: {
      type: String,
      required: false,
      default: ''
    }
  },

  methods: {

    formataDataBr
  }
}
</script>
<style scoped>
.titulo {
  color: dimgray;
  font-weight: bold;
}
</style>